import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Button,
  Dialog, 
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  Grid,
  Typography,
  Box
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { DataGrid } from "@mui/x-data-grid"
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik, useField } from "formik";
import { useDropzone } from "react-dropzone";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import TriplistApi from "Services/Triplist";

const ServiceDelete = (props) => {
  const { openDialog, id, handleClose } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();

  // Fetch Service Details

  const handleDeleteServicetype = () => {

dispatch(showLoader("Loading please wait..."));
const data = {
  ride_id: id
};
console.log('data--->',data);

const onSuccess = (res) => {
dispatch(hideLoader());
if (res?.data?.status === true) {
dispatch(
  showSnackbar({
    message: res?.data?.message || "Ride Cancelled Successfully",
    autoHideDuration: 3000,
    anchorOrigin: {
      vertical: "top",
      horizontal: "right",
    },
    variant: "success",
  })
);
handleClose();
}
};
const onFailure = (err) => {
const messagesArray = err?.response?.data?.data || []; // Default to an empty array if no messages
const messages = messagesArray.map(item => item.msg).join(", "); // Join all `msg` values with a comma
dispatch(hideLoader());
dispatch(
showSnackbar({
  message: messages || "Error while cancel Ride",
  autoHideDuration: 3000,
  anchorOrigin: {
    vertical: "top",
    horizontal: "right",
  },
  variant: "error",
})
);
//console.log("update profile details api", err);
};

TriplistApi.cancelridebydispatcheroradmin({ ...data }).then(onSuccess, onFailure); 

  };

  return (
    <>
     <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Are you sure cancel this current ride ?"}
        </DialogTitle>
        <DialogContent>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Disagree
          </Button>
          <Button onClick={handleDeleteServicetype} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    </>
  );
};

export default ServiceDelete;
